import { Reveal } from "./Reveal";
import { Kicker } from "./Sections";

export const PageHeader = ({ kicker, title, sub }) => (
  <section className="relative bg-navy overflow-hidden pt-32 md:pt-40 pb-16 md:pb-20" data-testid="page-header">
    <div className="absolute inset-0 grid-lines pointer-events-none" />
    <div className="absolute -right-24 -top-24 w-96 h-96 rounded-full bg-sapphire/20 blur-3xl pointer-events-none" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        {kicker && <Kicker>{kicker}</Kicker>}
        <h1 className="mt-4 font-heading font-black tracking-tighter text-4xl md:text-5xl lg:text-6xl text-white max-w-3xl leading-[0.98]">{title}</h1>
        {sub && <p className="mt-5 max-w-xl text-lg text-white/70">{sub}</p>}
      </Reveal>
    </div>
  </section>
);
